/**
 * Shared copy for Maintenance History / My Work Logs advanced filter drawers.
 */

export const ADVANCED_FILTER_HINTS = {
  mutualExclusivityBanner:
    'Maintenance Type applies to maintenance records; Status and Severity apply to complaints and can be combined.',
  departmentRestricted: '(restricted)',
  maintenanceTypeDisabled: '(disabled — Complaint filters active)',
  complaintFiltersDisabled: '(disabled — Maintenance filters active)',
};

export const FilterTitleHint = ({ children }) => {
  if (!children) {
    return null;
  }

  return (
    <span style={{ fontSize: '0.7rem', color: '#999', marginLeft: '0.5rem' }}>
      {children}
    </span>
  );
};
